import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Input,
  Button,
  Typography,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import {
  getAllProductsByCategory,
  getCategories,
  getPropertiesByProduct,
  getPropertyValues,
  mainCommoditiesOffer,
  spiceOffer,
  buildingMaterialsOffer,
  grainsOffer,
  PulsesOffer,
  oilSeedsOffer,
  rootCropsOffer,
  VegetablesOffer,
  fruitCropsOffer,
  getProductById,
  getUserByPhoneNumber,
} from "../../services/productServices";
// import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateUser } from "../../services/userServices";
import { Dialog, DialogBody, DialogFooter, DialogHeader ,  Button as DialogButton,
} from "@material-tailwind/react";

// Regex to detect phone numbers (expects unformatted string, e.g., "935148825")
const phoneRegex = /^[79][0-9]{8}$/;

// Helper function to format a phone number for display as +251-XXXXXXXXX
const formatPhoneNumber = (phone) => {
  if (!phone) return "";
  let digits = phone.replace(/\D/g, "");

  // If it already starts with 251 and is followed by 9 digits (Ethiopian format)
  if (digits.startsWith("251") && digits.length === 12) {
    return `+${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  // If it starts with 0, remove it
  if (digits.startsWith("0")) {
    digits = digits.substring(1);
  }

  // Add +251 if it doesn't already have the country code
  return `+251-${digits}`;
};

export function Posting_form_admin() {
  // const navigate = useNavigate();

  const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;


  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Sell");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");

  const [commodityProperties, setCommodityProperties] = useState([]);
  const [propertyValues, setPropertyValues] = useState({});
  // const [chatId, setChatId] = useState("");
  const [selectedCommodityName, setSelectedCommodityName] = useState("");

  const [productDescription, setProductDescription] = useState("");

  const [quantity, setQuantity] = useState(null);
  const [measurementType, setMeasurementType] = useState("");

  const [price, setPrice] = useState(null);
  const [currency, setCurrency] = useState("Birr");

  // User-related states
  const [userName, setUserName] = useState("");
  // The phoneNumber state will hold raw unformatted digits (e.g., "935148825")
  const [phoneNumber, setPhoneNumber] = useState("");
  const [posterId, setPosterId] = useState("");
  // State to hold the fetched user object (if any)
  const [fetchedUser, setFetchedUser] = useState(null);
  const [userChatId, setUserChatId] = useState(null);
  const [isUpdatingUser, setIsUpdatingUser] = useState(false);
  const [hasUserChanges, setHasUserChanges] = useState(false);
  const [hasSelectedUser, setHasSelectedUser] = useState(false);
  const [country, setCountry] = useState(0);
  const COUNTRIES = ["Ethiopia(+251)"];
  const CODES = ["+251"];

  // Category & Product Lists
  const [categories, setCategories] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const suppressSearchRef = useRef(false);
  const [measurementOptions, setMeasurementOptions] = useState([]);
  const [userIsVerified, setUserIsVerified] = useState(false);
  // Track if the app is loaded via Telegram
  // const [loadedFromTelegram, setLoadedFromTelegram] = useState(false);

    // Image upload state
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [uploadedFileLink, setUploadedFileLink] = useState("");
  const [showMediaDialog, setShowMediaDialog] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const offerFunctionMapping = {
    "Coffee / ቡና": mainCommoditiesOffer,
    "Spice & Herbs / ቅመማ ቅመሞቾ": spiceOffer,
    "Building Materials / የግንባታ እቃዎች": buildingMaterialsOffer,
    "Grains and Cereals / የእህል ሰብሎች": grainsOffer,
    "Pulses & Legumes / ጥራጥሬዎች ": PulsesOffer,
    "Oil Seeds / የቅባት እህሎች": oilSeedsOffer,
    "Root Crops / የስራስር ሰብሎች": rootCropsOffer,
    "Vegetables  / አትክልቶች": VegetablesOffer,
    "Fruit Crops / ፍራፍሬች": fruitCropsOffer,
  };

  // Ref for debouncing phone search.
  const phoneSearchTimeout = useRef(null);
  // State to control loading icon for user search.
  const [searchingUser, setSearchingUser] = useState(false);

  // 1) Fetch categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const categoriesData = await getCategories();
        setCategories(categoriesData || []);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch categories.");
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  // 2) When a category is selected, fetch its products
  useEffect(() => {
    if (!selectedCategory) return;

    const fetchProducts = async () => {
      try {
        setLoading(true);
        let products;
        if (selectedCategory === "Roasted Coffee") {
          const roastedCoffeeId = 11;
          const product = await getProductById(
            roastedCoffeeId,
            selectedCategory
          );
          products = [product];
        } else {
          products = await getAllProductsByCategory(selectedCategory);
        }
        setAllProducts(products || []);
        if (products && products.length === 1) {
          setSelectedProductId(products[0].id);
          setSelectedCommodityName(products[0].name);
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch products.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [selectedCategory]);

  // 3) Check if launched via Telegram and get Telegram info (if available)
  // useEffect(() => {
  //   if (Object.keys(window.Telegram.WebApp.initDataUnsafe).length !== 0) {
  //     const { user } = window.Telegram.WebApp.initDataUnsafe;
  //     if (user) {
  //       const { id } = user;
  //       setChatId(id);
  //       setLoadedFromTelegram(true);
  //     }
  //   }
  // }, []);

  // 4) When a product is selected, fetch its properties and values
  useEffect(() => {
    if (!selectedProductId || !selectedCategory) return;

    const fetchPropsAndValuesAndMeasurements = async () => {
      try {
        setLoading(true);

        // 3a) Fetch commodity properties & their values
        const propsResponse = await getPropertiesByProduct(
          selectedProductId,
          selectedCategory
        );
        setCommodityProperties(propsResponse);

        const tempValuesMap = {};
        for (const prop of propsResponse) {
          const valResponse = await getPropertyValues(
            selectedProductId,
            prop.id,
            selectedCategory
          );
          tempValuesMap[prop.id] = valResponse;
        }
        setPropertyValues(tempValuesMap);

        // 3b) Fetch the full product (so we can read its "measurement" field)
        const fullProduct = await getProductById(
          Number(selectedProductId),
          selectedCategory
        );
        // fullProduct.measurement is a JSON‐encoded string, e.g. "[\"liter / lit / 22\",\"trr / ggg / 3\"]"
        if (fullProduct.measurement) {
          try {
            const parsed = JSON.parse(fullProduct.measurement);
            // parsed is now an array of strings: ["liter / lit / 22", "trr / ggg / 3"]
            if (Array.isArray(parsed)) {
              setMeasurementOptions(parsed);
            } else {
              setMeasurementOptions([]);
            }
          } catch (e) {
            console.error("Failed to parse measurement field:", e);
            setMeasurementOptions([]);
          }
        } else {
          setMeasurementOptions([]);
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch product details.");
      } finally {
        setLoading(false);
      }
    };

    fetchPropsAndValuesAndMeasurements();
  }, [selectedProductId, selectedCategory]);

  // Auto-resize for description textarea.
  const descriptionRef = useRef(null);
  const handleDescriptionChange = (e) => {
    setProductDescription(e.target.value);
    if (descriptionRef.current) {
      descriptionRef.current.style.height = "auto";
      descriptionRef.current.style.height =
        descriptionRef.current.scrollHeight + "px";
    }
  };

  // Validate phone number (expects unformatted input, e.g., "935148825")
  const isValidPhoneNumber = (phone) => {
    if (phone.startsWith("0")) return false;
    return phoneRegex.test(phone);
  };

  const fetchUserByPhoneOrChatId = async (phone, chatId) => {
    try {
      setSearchingUser(true);

      const fullPhone = phone ? `0${phone}` : undefined;
      
      const response = await getUserByPhoneNumber(fullPhone, chatId);

      if (response && response.exists && response.user) {
        const u = response.user;
        setFetchedUser(u);
        // handle both numeric and string flags
        setUserIsVerified(
          Number(u.is_verified) === 1 // "1" → 1, 1 → 1
        );
      } else {
        setFetchedUser(null);
        toast.warn("User not found for this phone number or chat ID.", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      toast.error("Could not fetch user info.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } finally {
      setSearchingUser(false);
    }
  };

  // const handleSelectFetchedUser = () => {
  //   if (fetchedUser) {
  //     suppressSearchRef.current = true;
  //     setOriginalUserName(fetchedUser.name);

  //     setUserName(fetchedUser.name);
  //     const rawPhone = fetchedUser?.contact_information;
  //     if (rawPhone && typeof rawPhone === "string") {
  //       const trimmedPhone = rawPhone.trim();
  //       if (trimmedPhone) {
  //         const normalized = trimmedPhone.startsWith("0")
  //           ? trimmedPhone.substring(1)
  //           : trimmedPhone;
  //         setPhoneNumber(normalized);
  //       } else {
  //         setPhoneNumber("");
  //       }
  //     } else {
  //       setPhoneNumber("");
  //     }
  //     setPosterId(fetchedUser.id);
  //     setUserChatId(fetchedUser.chat_id);

  //     setFetchedUser(null);

  //     setTimeout(() => {
  //       suppressSearchRef.current = false;
  //     }, 500);
  //   }
  // };

  const handleSelectFetchedUser = () => {
    if (!fetchedUser) return;

    suppressSearchRef.current = true;

    // Populate form fields
    setUserName(fetchedUser.name);
    const raw = (fetchedUser.contact_information || "").trim();
    const normalized = raw.startsWith("0") ? raw.substring(1) : raw;
    setPhoneNumber(normalized);

    // Save other IDs
    setPosterId(fetchedUser.id);
    setUserChatId(fetchedUser.chat_id);

    // Set verification status
    const isVerified = fetchedUser.is_verified === "1" || fetchedUser.is_verified === 1;
    setUserIsVerified(isVerified);

    // Clear fetchedUser and mark as selected
    setFetchedUser(null);
    setHasSelectedUser(true);
    setHasUserChanges(false);

    // Re-enable auto-search after debounce
    setTimeout(() => {
      suppressSearchRef.current = false;
    }, 500);
  };

  const handleUserInfoChange = (field, value) => {
    if (field === 'name') setUserName(value);
    if (field === 'phone') setPhoneNumber(value.replace(/\D/g, ""));
    setHasUserChanges(true);
  };

  const handleUpdateUser = async () => {
    setIsUpdatingUser(true);
    try {
      const contact = phoneNumber ? `0${phoneNumber}` : "";
      await updateUser({
        id: posterId,
        chat_id: userChatId,
        name: userName,
        contact_information: contact || undefined,
      });

      toast.success("User updated successfully", { position: "top-center" });
      setHasUserChanges(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update user", { position: "top-center" });
    } finally {
      setIsUpdatingUser(false);
    }
  };

  useEffect(() => {
    if (suppressSearchRef.current) return;

    if (phoneSearchTimeout.current) clearTimeout(phoneSearchTimeout.current);

    const isPhoneValid =
      phoneNumber.length === 9 && isValidPhoneNumber(phoneNumber);
    const isChatIdValid =
      typeof userChatId === "string" && userChatId.trim().length > 0;

    if (isPhoneValid || isChatIdValid) {
      phoneSearchTimeout.current = setTimeout(() => {
        fetchUserByPhoneOrChatId(
          isPhoneValid ? phoneNumber : null,
          isChatIdValid ? userChatId.toString().trim() : null
        );
      }, 300);
    }
  }, [phoneNumber, userChatId]);

  // Handle form submission.
  const handlePost = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // 0) Require both userName and phoneNumber
    if (!userName.trim() && !phoneNumber.trim()) {
      toast.error("Enter username or phone number", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
      });
      setIsSubmitting(false);
      return;
    }

    // 1) Require chat ID
    if (!userChatId || !userChatId.toString().trim()) {
      toast.error("Enter Chat ID", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
      });
      setIsSubmitting(false);
      return;
    }

    // if (!phoneNumber.trim()) {
    //   toast.error("Enter Phone number", {
    //     position: "top-center",
    //     autoClose: 3000,
    //     hideProgressBar: true,
    //   });
    //   setIsSubmitting(false);
    //   return;
    // }

    if (phoneRegex.test(productDescription)) {
      toast.error(
        "Entering contact information in the description is not allowed. Please remove any phone numbers.",
        { position: "top-center", autoClose: 5000, hideProgressBar: true }
      );
      setIsSubmitting(false);
      return;
    }

    if (phoneNumber && !isValidPhoneNumber(phoneNumber)) {
      toast.error(
        "Invalid phone number. It must not start with 0, must start with 7 or 9, and be 9 digits long.",
        { position: "top-center", autoClose: 5000, hideProgressBar: true }
      );
      setIsSubmitting(false);
      return;
    }

    const formattedPhoneNumber = phoneNumber ? `0${phoneNumber}` : null;

    const userInfo = {
      user_name: userName,
      phone_number: formattedPhoneNumber,
      chat_id: userChatId,
      business_type: null,
      is_featured: null,
    };

    const selectedPropertyValues = {};
    commodityProperties.forEach((prop) => {
      const selectedValue = propertyValues[prop.id]?.selectedValue;
      if (selectedValue) {
        selectedPropertyValues[prop.name.toLowerCase()] = selectedValue;
      }
    });

    const newProduct = {
      product_name: selectedCommodityName,
      posted_from: "web",
      productId: selectedProductId,
      description: productDescription,
      quantity,
      status: true,
      measurement: measurementType,
      price,
      poster: "admin",
      currency,
      categoryName: selectedCategory,
      offer_type: selectedOption.toLowerCase(),
      ...selectedPropertyValues,
      ...userInfo,
      image: uploadedFileName || "",
      image_filelink: uploadedFileLink || "",
    };

    const offerFunction = offerFunctionMapping[selectedCategory];
    if (!offerFunction) {
      toast.error("Selected category does not support offers.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
      });
      setIsSubmitting(false);
      return;
    }

    try {
      await offerFunction(newProduct);

      window.location.reload();
      // navigate("/offerSuccess");
      setSelectedOption("Sell");
      setSelectedCategory("");
      setAllProducts([]);
      setSelectedProductId("");
      setSelectedCommodityName("");
      setCommodityProperties([]);
      setPropertyValues({});
      setProductDescription("");
      setQuantity("");
      setMeasurementType("");
      setPrice("");
      setCurrency("Birr");
      setUserName("");
      setPhoneNumber("");
      setPosterId("");
      setFetchedUser(null);
    } catch (error) {
      console.error("Error posting offer:", error);
      toast.error("There was an error saving your offer. Please try again.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const uploadImage = async () => {
      if (!selectedFile || !selectedCategory || !selectedProductId) {
        toast.error("Please select Category and Product first.");
        return;
      }
      // console.log(selectedCategory, allProducts[Number(selectedProductId) - 1].name, allProducts)
      // const extension = selectedFile.name.split(".").pop();
      const timestamp = Date.now();
      const fileName = `${selectedCategory.split('/')[0].trim()}_${(allProducts[Number(selectedProductId) - 1].name).split('/')[0].trim()}_${timestamp}`;

      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("fileName", fileName);
      console.log(fileName, selectedFile.name);
      try {
        setUploading(true);
        setUploadProgress(0);

        const res = await axios.post(
          `${BASE_URL}/Fileupload/uploadImage`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(progress);
            },
          }
        );

        setUploadedFileName(selectedFile.name);
        setUploadedFileLink(res.data.filelink)
        setUploadProgress(100);
        toast.success("Image uploaded successfully!");
        console.log(uploadedFileName, uploadedFileLink);
      } catch (err) {
        console.error(err);
        toast.error("Image upload failed.");
      } finally {
        setUploading(false);
      }
    };

  return (
    <div className=" flex flex-col">
      <div className="lg:flex lg:flex-row lg:items-center justify-center  lg:flex-1 lg:px-52 sm:px-8 md:px-32 lg:mt-3 mb-5 ">
        <div className=" rounded-lg lg:shadow-lg sm:shadow-none lg:p-8 px-14 w-full max-w-xl">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-semibold">I want to</h1>
          </div>
          <div className="flex space-x-4 mb-6">
            <button
              type="button"
              className={`px-6 py-2 rounded-full ${
                selectedOption === "Sell"
                  ? "bg-green-500 text-white"
                  : "bg-gray-200"
              }`}
              onClick={() => setSelectedOption("Sell")}
            >
              Sell
            </button>
            <button
              type="button"
              className={`px-6 py-2 rounded-full ${
                selectedOption === "Buy"
                  ? "bg-green-500 text-white"
                  : "bg-gray-200"
              }`}
              onClick={() => setSelectedOption("Buy")}
            >
              Buy
            </button>
          </div>
          <form onSubmit={handlePost}>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Commodity Category *
              </label>
              <select
                className="w-full border border-gray-300 rounded-md p-2"
                value={selectedCategory}
                onChange={(e) => {
                  setSelectedCategory(e.target.value);
                  setSelectedProductId("");
                  setSelectedCommodityName("");
                }}
              >
                <option value="">Select Category</option>
                {loading ? (
                  <option>Loading...</option>
                ) : error ? (
                  <option>{error}</option>
                ) : (
                  categories.map((cat) => (
                    <option key={cat.id} value={cat.name}>
                      {cat.name}
                    </option>
                  ))
                )}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Product Name *
              </label>
              <select
                className="w-full border border-gray-300 rounded-md p-2"
                value={selectedProductId}
                onChange={(e) => {
                  const productId = e.target.value;
                  setSelectedProductId(productId);
                  const p = allProducts.find(
                    (prd) => String(prd.id) === productId
                  );
                  setSelectedCommodityName(p?.name || "");
                  // Clear previous measurementType when product changes
                  setMeasurementType("");
                }}
                disabled={!selectedCategory}
              >
                <option value="">Select Product</option>
                {loading ? (
                  <option>Loading...</option>
                ) : error ? (
                  <option>{error}</option>
                ) : (
                  allProducts.map((product) => (
                    <option key={product.id} value={product.id}>
                      {product.name}
                    </option>
                  ))
                )}
              </select>
            </div>
            {commodityProperties.length > 0 && (
              <div className="mb-4 p-4 border rounded-md bg-gray-50">
                <h2 className="font-semibold mb-2">Commodity Properties</h2>
                {commodityProperties.map((prop) => (
                  <div key={prop.id} className="mb-2">
                    <label className="block text-gray-700 mb-1">
                      {prop.name}:
                    </label>
                    <select
                      className="w-full border border-gray-300 rounded-md p-2"
                      value={
                        (propertyValues[prop.id] &&
                          propertyValues[prop.id].selectedValue) ||
                        ""
                      }
                      onChange={(e) => {
                        setPropertyValues((prevValues) => {
                          const current = prevValues[prop.id];
                          const options = Array.isArray(current)
                            ? current
                            : current?.values || [];
                          return {
                            ...prevValues,
                            [prop.id]: {
                              values: options,
                              selectedValue: e.target.value,
                            },
                          };
                        });
                      }}
                    >
                      <option value="">Select {prop.name}</option>
                      {(Array.isArray(propertyValues[prop.id])
                        ? propertyValues[prop.id]
                        : propertyValues[prop.id]?.values || []
                      ).map((valObj, idx) => (
                        <option key={idx} value={valObj.value}>
                          {valObj.value}
                        </option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>
            )}
            {/* ===== Simplified Upload Button + Popup ===== */}
              {selectedOption === "Sell" && (
                <div className="mb-4">
                  <label className="block text-gray-700 font-medium mb-2">
                    Product Photo / የምርት ምስል ያክሉ
                  </label>

                  {/* Upload Media Button */}
                  <button
                    type="button"
                    
                    className={`font-semibold px-4 py-2 rounded transition ${
                      uploadedFileName
                        ? "bg-green-600 text-white"
                        : "bg-green-500 text-white hover:bg-green-300 text-white"
                    }`}
                    onClick={() => 
                      {
                      if(!selectedProductId || !selectedCategory){
                          toast.error("Please select Category and Product first.");
                        }
                        else{
                          setShowMediaDialog(true);
                        }  
                    }}
                  >
                    {uploadedFileName ? "✅ Photo Uploaded, Click to Change" : "Upload Photo"}
                  </button>

                  {/* Uploaded File Info */}
                  {(
                    <p className="text-sm text-green-700 mt-2">
                      <span className="font-medium">{uploadedFileName ? " Uploaded: " + uploadedFileName : 'Select Category and Product first.'}</span>
                    </p>
                  )}
                </div>
              )}

                {/* ===== Upload Dialog ===== */}
                {showMediaDialog && (
                  <div className="dialog-container">
                  <Dialog className="dialogM" open={showMediaDialog} handler={() => setShowMediaDialog(false)} size="xs">
                  <DialogHeader>Upload Photo</DialogHeader>

                    <DialogBody>
                      <div className="flex flex-col space-y-4 items-center">

                        {/* ===== Image Preview Placeholder ===== */}
                        <div className="w-48 h-48 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center overflow-hidden">
                          {selectedFile ? (
                            <img
                              src={URL.createObjectURL(selectedFile)}
                              alt="Selected preview"
                              className="object-cover w-full h-full"
                            />
                          ) : uploadedFileLink ? (
                            <img
                              src={uploadedFileLink}
                              alt="Uploaded media"
                              className="object-cover w-full h-full"
                            />
                          ) : (
                            <span className="text-gray-400 text-sm text-center px-2">
                              No image selected
                            </span>
                          )}
                        </div>
                        {uploadError && (
                            <p className="text-red-500 text-sm mt-2">{uploadError}</p>
                          )}

                        {/* ===== Choose File Button ===== */}
                        <input
                          type="file"
                          accept="image/*"
                          id="mediaInput"
                          className="hidden"
                          onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) return;

                          const maxSize = 1 * 1024 * 1024; // 1MB

                          if (file.size > maxSize) {
                            setUploadError("Photo must be less than 1MB. / ምስሉ ከ1MB በታች መሆን አለበት።");
                            setSelectedFile(null);
                            return;
                          }
                          setUploadError(""); 
                          setSelectedFile(file);
                        }}
                        />

                        <button
                          type="button"
                          className="bg-gray-100 border border-gray-300 rounded-lg px-4 py-2 hover:bg-gray-200 text-sm"
                          onClick={() => document.getElementById("mediaInput").click()}
                        >
                          {selectedFile ? "Change Image" : "Choose Photo from Gallery"}
                        </button>

                        {/* ===== Selected File Info ===== */}
                        {selectedFile && (
                          <p className="text-sm text-gray-600">
                            Selected: <span className="font-medium">{selectedFile.name}</span>
                          </p>
                        )}

                        {/* ===== Upload Button ===== */}
                        <button
                          type="button"
                          disabled={uploadError || uploading}
                          onClick={async () => {
                            if (!selectedFile) return;
                            setUploading(true);
                            await uploadImage();
                            setUploading(false);
                            setShowMediaDialog(false);
                          }}
                          className={`w-[200px] py-2 rounded text-white font-medium transition ${
                            uploading ? "bg-gray-400 cursor-wait" : "bg-green-500 text-white hover:bg-green-300 text-white"
                          }`}
                        >
                          {uploading ? (
                            <div className="flex items-center justify-center space-x-2">
                              <svg
                                className="animate-spin h-5 w-5 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v8H4z"
                                ></path>
                              </svg>
                              <span>Uploading...</span>
                            </div>
                          ) : (
                            "Upload"
                          )}
                        </button>
                      </div>
                    </DialogBody>


                  <DialogFooter className="dialogFooter">
                    {!uploading && (
                      <DialogButton
                        variant="text"
                        onClick={() => setShowMediaDialog(false)}
                        className="cancelButton"
                      >
                        Cancel
                      </DialogButton>
                    )}
                  </DialogFooter>
                  </Dialog>
                </div>
                )}
              {/* ===== End of Upload Button + Popup ===== */}
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Product Description *
              </label>
              <textarea
                ref={descriptionRef}
                className="w-full border border-gray-300 rounded-md p-2 resize-none overflow-hidden"
                placeholder="Enter description"
                value={productDescription}
                onChange={handleDescriptionChange}
              />
            </div>
            {/* User Info Inputs */}
            <div className="mb-4">
              <label className="flex items-center text-gray-700 font-medium mb-2">
                Name of User
                {userIsVerified && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-green-500 ml-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                )}
              </label>
              <input
                id="user_name_input"
                type="text"
                className="w-full border border-gray-300 rounded-md p-2"
                placeholder="Enter your name"
                value={userName}
                onChange={(e) => handleUserInfoChange('name', e.target.value)}
              />
            </div>

            <div className="mb-4">
              <Typography
                variant="small"
                color="blue-gray"
                className="block text-gray-700 font-medium mb-2"
              >
                Enter chatId *
              </Typography>
              <Input
                value={userChatId}
                onChange={(e) => setUserChatId(e.target.value)}
                type="text"
                inputMode="alpha-numeric"
                placeholder="Enter chatId"
                className="appearance-none rounded-l-none !border-t-blue-gray-200 placeholder:text-blue-gray-300 placeholder:opacity-100 focus:!border-t-gray-900 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                labelProps={{
                  className: "before:content-none after:content-none",
                }}
                containerProps={{ className: "min-w-0" }}
              />
            </div>

            <div className="mb-4">
              <Typography
                variant="small"
                color="blue-gray"
                className="block text-gray-700 font-medium mb-2"
              >
                Phone Number
              </Typography>

              <div className="relative flex w-full items-center">
                <Menu placement="bottom-start">
                  <MenuHandler>
                    <Button
                      ripple={false}
                      variant="text"
                      color="blue-gray"
                      className="h-10 w-14 shrink-0 rounded-r-none border border-r-0 border-blue-gray-200 bg-transparent px-3"
                    >
                      {CODES[country]}
                    </Button>
                  </MenuHandler>
                  <MenuList className="max-h-[20rem] max-w-[18rem]">
                    {COUNTRIES.map((countryName, index) => (
                      <MenuItem
                        key={countryName}
                        value={countryName}
                        onClick={() => setCountry(index)}
                      >
                        {countryName}
                      </MenuItem>
                    ))}
                  </MenuList>
                </Menu>
                <Input
                  value={phoneNumber}
                  onChange={(e) => handleUserInfoChange('phone', e.target.value)}
                  type="tel"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  maxLength={9}
                  placeholder="912345678"
                  className="appearance-none rounded-l-none !border-t-blue-gray-200 placeholder:text-blue-gray-300 placeholder:opacity-100 focus:!border-t-gray-900 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                  labelProps={{
                    className: "before:content-none after:content-none",
                  }}
                  containerProps={{ className: "min-w-0" }}
                />
                {searchingUser && (
                  <div className="absolute right-2 animate-spin border-2 border-t-blue-500 border-gray-300 rounded-full w-5 h-5" />
                )}
              </div>
            </div>
            {/* Fetched user card */}
            {fetchedUser && (
              <div className="mb-4 p-4 border rounded-md bg-gray-100">
                <Typography className="font-medium mb-2">
                  Fetched User:
                </Typography>
                <p>
                  <strong>Name:</strong> {fetchedUser.name}
                </p>
                {fetchedUser.contact_information && (
                  <p>
                    <strong>Phone:</strong>{" "}
                    {formatPhoneNumber(fetchedUser.contact_information)}
                  </p>
                )}
                {fetchedUser.chat_id && (
                  <p>
                    <strong>Chat ID:</strong> {fetchedUser.chat_id}
                  </p>
                )}
                <Button
                  size="sm"
                  color="blue"
                  className="mt-2"
                  onClick={handleSelectFetchedUser}
                >
                  Use this user
                </Button>
              </div>
            )}
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Product Quantity
              </label>
              <div className="flex space-x-2">
                <input
                  type="number"
                  step="any"
                  className="w-1/2 border border-gray-300 rounded-md p-2"
                  placeholder="Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
                <select
                  className="w-1/2 border border-gray-300 rounded-md p-2"
                  value={measurementType}
                  onChange={(e) => setMeasurementType(e.target.value)}
                  disabled={measurementOptions.length === 0}
                >
                  <option value="">
                    {measurementOptions.length
                      ? "Select Unit"
                      : "No units available"}
                  </option>
                  {measurementOptions.map((opt, idx) => {
                    // opt is e.g. "liter / lit / 22"
                    // For display, show just "liter / lit"
                    const parts = opt.split(" / ");
                    const label = parts.slice(0, 2).join(" / "); // "liter / lit"
                    return (
                      <option key={idx} value={opt}>
                        {label}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="flex justify-end mt-6 space-x-2">
              {console.log('Button conditions:', {
                userIsVerified,
                hasSelectedUser,
                hasUserChanges
              })}
              {!userIsVerified && hasSelectedUser && hasUserChanges && (
                <button
                  type="button"
                  onClick={handleUpdateUser}
                  disabled={isUpdatingUser}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                >
                  {isUpdatingUser ? "Saving…" : "Update User"}
                </button>
              )}
              <button
                type="submit"
                className="bg-green-500 text-white px-6 py-2 rounded-md"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Posting..." : "Post"}
              </button>
            </div>
          </form>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default Posting_form_admin;
